import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter } from '@/components/ui/drawer'
import { Stack } from '@/components/ui/stack'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import { mobileUploadDrawerAtom, toggleUploadMobileDrawer } from '@/store/gigiChat/ChatAtom'

import DropZone from '../../../dropzone'
import UploadedFiles from '../../uploadedFiles'
import UploadingDocuments from '../../uploadingDocuments'

const MobileUploadDrawer = () => {
    const { t } = useTranslation()
    const [isOpen] = useAtom(mobileUploadDrawerAtom)
    const [isMobile] = useCustomMediaQuery()
    const onClose = () => {
        toggleUploadMobileDrawer()
    }
    const borderColor = useColorModeValue('gray.300', 'gray.700')
    return (
        <DrawerDialog isOpen={isMobile ? isOpen : false} onClose={onClose} size="lg" noPadding={true}>
            <DrawerBody p="0" px="24px" mb="16px">
                <Stack height="100%">
                    <UploadingDocuments />
                    <DropZone />
                    <UploadedFiles />
                </Stack>
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor={borderColor} display="block" mx="24px" px="0" py="24px">
                <Button variant="secondary" mr="18px" onClick={onClose} textTransform="uppercase" letterSpacing="0.25px">
                    {t('documents.mobile.drawer.buttons.close')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default MobileUploadDrawer
